import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {LoadingIndicator} from "../../../core/components/loading/loading-indicator";
import classNames from 'classnames';
import styles from '../styles/related-entities-widget.module.scss';

const RelatedEntitiesWidgetAsyncComponent = AsyncComponent(async () => import('./related-entities-widget' /* webpackChunkName: "related-entities-widget" */ ));

export const RelatedEntitiesWidgetAsync = (props) => {
  return <React.Suspense fallback={<div className={classNames(styles.placeholder)}><LoadingIndicator/></div>}>
    <RelatedEntitiesWidgetAsyncComponent {...props}/>
  </React.Suspense>
};
